import React from 'react';

interface BrandLogoProps {
  variant?: 'full' | 'icon';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  theme?: 'light' | 'dark' | 'auto';
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  variant = 'full',
  size = 'md',
  className = '',
  theme = 'auto',
}) => {
  const iconSize = size === 'sm' ? 32 : size === 'lg' ? 44 : 38;
  const svgSize = size === 'sm' ? 18 : size === 'lg' ? 24 : 20;

  return (
    <div className={`inline-flex items-center gap-3 select-none ${className}`}>
      {/* Icon Shield Badge */}
      <div
        className="relative flex items-center justify-center rounded-xl bg-blue-600 text-white shadow-sm ring-1 ring-black/5 dark:ring-white/10 transition-transform duration-200"
        style={{ width: iconSize, height: iconSize }}
      >
        <svg
          width={svgSize}
          height={svgSize}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      </div>

      {/* Brand Typography */}
      {variant === 'full' && (
        <div className="flex flex-col leading-tight">
          <span
            className={`font-black tracking-tight ${
              theme === 'dark' ? 'text-white' : 'text-slate-900'
            } ${size === 'sm' ? 'text-base' : size === 'lg' ? 'text-xl' : 'text-lg'}`}
          >
            Claims<span className="text-blue-600">AI</span>
          </span>
          <span className="text-[11px] font-medium text-slate-500 dark:text-slate-400">
            Fraud & Clinical Intelligence
          </span>
        </div>
      )}
    </div>
  );
};

export default BrandLogo;

